'use client';

import { ChatRoomProps } from '../../types/chat';
import { MessageInput } from '../atoms/MessageInput';
import { ChatHeader } from '../molecules/ChatHeader';
import { MessageList } from '../molecules/MessageList';

export function ChatRoom({ contact, messages, onBack, onSendMessage }: ChatRoomProps) {
  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <ChatHeader contact={contact} onBack={onBack} />

      {/* Messages */}
      <MessageList messages={messages} chatId={contact.id} />

      {/* Message input */}
      <MessageInput
        onSendMessage={onSendMessage}
        placeholder={`${contact.name}님에게 메시지 보내기...`}
      />
    </div>
  );
}